var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContatoHeadset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 309.5,
    height: 111.559,
    viewBox: "0 0 309.5 111.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-146 -285.987)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.868 -280.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.99,580.864a11.33,11.33,0,0,0-.821-2.1,9.162,9.162,0,0,0-4.577-4.354,2.92,2.92,0,0,0-1.225-.5l-6.974-1.09a2.991,2.991,0,0,0-3.413,2.464l-5.533,33.1a3,3,0,0,0,2.449,3.45l6.429,1.1a3,3,0,0,0,.508.037l.1-.015c.239.022.478.06.717.06a9.1,9.1,0,0,0,6.243-2.658,11.332,11.332,0,0,0,1.471-1.732,12.032,12.032,0,0,0,1.367.112,11.576,11.576,0,0,0,4-.709l-.754,4.525c-.022.172-.575,4.107-5.421,7.706-4.779,3.547-14.165,7-32.281,5.511a8.483,8.483,0,0,0-6.646-4.846c-4.443-.747-8.513,1.478-9.1,4.958s2.546,6.9,6.989,7.646a8.8,8.8,0,0,0,7.31-1.852q5.164.47,9.79.47c12.142,0,21.454-2.442,27.808-7.31s7.355-10.447,7.49-11.522l2.718-16.279-.037-.007.47-2.793A11.724,11.724,0,0,0,168.99,580.864Zm3.159,12.373-.784,4.727a5.717,5.717,0,0,1-4.63,4.66l2.561-15.3A5.712,5.712,0,0,1,172.149,593.237Zm-13.4,12.784a3.025,3.025,0,0,1-2.4.971l-.007.03h-.008l-3.487-.6L157.4,579.2l3.495.545-.007.068a3.066,3.066,0,0,1,1.964,1.71,7.427,7.427,0,0,1,.582,4.517l-2.658,15.9A7.426,7.426,0,0,1,158.753,606.021Z",
    transform: "translate(34.421 43.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.335,575.116a3.006,3.006,0,0,0-3.51-2.33l-6.922,1.359a2.886,2.886,0,0,0-1.217.553,9.175,9.175,0,0,0-4.4,4.525,13.272,13.272,0,0,0-.851,8.3l3.271,15.786c1.18,5.675,5.526,9.7,10.118,9.7a7.37,7.37,0,0,0,.911-.1l.09.015a2.973,2.973,0,0,0,.62-.067l6.385-1.344a3,3,0,0,0,2.315-3.539Zm-3.129,31.878-.008-.023c-1.635.336-3.958-1.68-4.622-4.884L116.305,586.3a7.411,7.411,0,0,1,.4-4.532,3.024,3.024,0,0,1,1.9-1.777l-.015-.075,3.472-.68,5.608,27.025Z",
    transform: "translate(0 43.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.356,613.752a13.6,13.6,0,0,1,2.419,1.479c-.06-15.584-3.808-27.667-11.164-35.948-7.811-8.8-19.624-13.269-35.208-13.284-15.48.015-27.286,4.488-35.1,13.284-7.445,8.386-11.186,20.669-11.156,36.537a13.636,13.636,0,0,1,2.875-2.031,7.9,7.9,0,0,1,2.83-1.143l.545-.112c.433-12.612,3.6-22.417,9.558-29.159a10.135,10.135,0,0,0,5.137,5.667,9.615,9.615,0,0,0,3.928.8,13.252,13.252,0,0,0,6.78-2,22.869,22.869,0,0,1,3.427-1.613l.052-.029a37.731,37.731,0,0,1,22.365,0l.052.037a21.983,21.983,0,0,1,3.427,1.6,13.252,13.252,0,0,0,6.78,2,9.579,9.579,0,0,0,3.92-.8,10.11,10.11,0,0,0,5.145-5.675l.022.023c5.907,6.653,9.088,16.458,9.573,29.19l.948.149A7.933,7.933,0,0,1,200.356,613.752Zm-21.05-30.362a3.39,3.39,0,0,1-1.389.268,6.113,6.113,0,0,1-1.77-.291,32.274,32.274,0,0,0-6.183-2.889l-.2-.075-.082.15.06-.157-.045-.008a40.893,40.893,0,0,0-13.187-2.068v.015l-.1-.023-.037.008a41.2,41.2,0,0,0-13.165,2.068l-.246.09a31.783,31.783,0,0,0-6.153,2.875,6.07,6.07,0,0,1-1.807.306,3.354,3.354,0,0,1-1.381-.268c-1.523-.68-2.248-2.778-2.584-4.473,6.392-4.466,14.95-6.728,25.426-6.736,10.484.008,19.034,2.27,25.434,6.736C181.545,580.612,180.821,582.71,179.305,583.39Z",
    transform: "translate(0.069 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5972 463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5932 -423)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 24,
    transform: "translate(243.5 313.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24,
    transform: "translate(255.5 325.5) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5898 -467)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 24,
    transform: "translate(243.5 313.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24,
    transform: "translate(255.5 325.5) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6140 -423)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 24,
    transform: "translate(243.5 313.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24,
    transform: "translate(255.5 325.5) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6169 -461)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 24,
    transform: "translate(243.5 313.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24,
    transform: "translate(255.5 325.5) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6349 -148)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(6118 -87)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContatoHeadset);
export default __webpack_public_path__ + "static/media/contato-headset.9b75113085ef93b6ad8ceeb36614fcd7.svg";
export { ForwardRef as ReactComponent };